export default {
  data: {},
  year: '2021',
  sepData: {},
};
